<span class="password-policy-popover"
    (mouseenter)="isOpen = true"
    (mouseleave)="isOpen = false">
    <img class="password-policy-popover__trigger pointer"
        src="/assets/images/infodoc-icon.svg"
        alt="Password requirements">
    <div class="password-policy-popover__panel"
        *ngIf="isOpen"
        [class.password-policy-popover__panel--top]="placement === 'top'"
        [class.password-policy-popover__panel--bottom]="placement === 'bottom'">
        <app-password-policy-hints layout="stack" [password]="password"></app-password-policy-hints>
    </div>
</span>
